import PropTypes from 'prop-types'
import React from 'react'
import { Button, Modal } from 'react-bootstrap'
import { confirmable } from 'react-confirm'

function ConfirmDialog({ show, proceed, cancel, dismiss, confirmation }) {
  return (
    <Modal show={show} onHide={dismiss}>
      <Modal.Header
        closeButton
        className="border-0 text-success font-weight-bold"
      >
        CONFIRM
      </Modal.Header>
      <Modal.Body>{confirmation}</Modal.Body>
      <Modal.Footer className="border-0">
        <Button variant="secondary" onClick={cancel}>
          NO
        </Button>
        <Button variant="warning" onClick={proceed}>
          YES
        </Button>
      </Modal.Footer>
    </Modal>
  )
}

ConfirmDialog.propTypes = {
  show: PropTypes.bool,
  proceed: PropTypes.func,
  cancel: PropTypes.func,
  dismiss: PropTypes.func,
  confirmation: PropTypes.string,
  options: PropTypes.object,
}

export default confirmable(ConfirmDialog)
